import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setHistoricalMode } from "@monorepo/slices/historicalPayment";
import { IHistoricalPaymentSliceState } from "@monorepo/types";

export const useHistoricalPayment = () => {
  const isHistorical = useSelector(
    ({ historicalPaymentSlice }: IHistoricalPaymentSliceState) => historicalPaymentSlice?.historical
  );

  const dispatch = useDispatch();

  const setHistorical = (enabled: boolean) => {
    dispatch(setHistoricalMode(enabled));
  };

  return { isHistorical, setHistorical };
};
